module.exports = __webpack_public_path__ + "img/combo.a6bac5f3.png";